export default __webpack_public_path__ + "static/media/SampleLoad.084761e7.csv";